export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const SET_IN_APP_NOTIFICATIONS = 'SET_IN_APP_NOTIFICATIONS';
